export const queryKeys = {
  controls: {
    all: ['controls'] as const,
    list: () => [...queryKeys.controls.all, 'list'] as const,
    attributes: (id: string = '') => [...queryKeys.controls.all, id, 'attributes'] as const,
    data: (id: string = '') => [...queryKeys.controls.all, id, 'data'] as const,
    historical: (id: string = '') =>
      [...queryKeys.controls.all, id, 'historical-execution'] as const,
    drillDown: (id: string = '', costCenterId: string = '', drillDownType: string = '') =>
      [...queryKeys.controls.all, id, 'drill-down', costCenterId, drillDownType] as const,
  },
  audits: {
    all: ['audits'] as const,
    list: () => [...queryKeys.audits.all, 'list'] as const,
    control: (
      id: string = '',
      lastEvaluatedKey: string = '',
      pageSize: number = 100,
      filters?: string
    ) => [...queryKeys.audits.all, id, lastEvaluatedKey, filters ?? ''] as const,
    code: (id: string = '', controlCode: string = '', lastEvaluatedKey?: string) =>
      [...queryKeys.audits.all, id, 'code', controlCode, lastEvaluatedKey ?? ''] as const,
  },
  preferences: {
    all: ['preferences'] as const,
    user: (id: string = '') => [...queryKeys.preferences.all, id] as const,
  },
} as const;
